@if (component) {
<div class="_grid">
    @for (tile of component.tiles; track tile) {
    <div class="block bg-col-w _itemBig p-a-10 p-a-5"
         [ngClass]="isSmallItem($index) ? '_itemSmall' : '_itemBig'">
        <div class="flex flex-middle">
            <i [ngClass]="tile.icon"
               class="inline-flex"></i>
            <p class="p2 m-l-2"
               *iCms="'title' of tile;"></p>
        </div>


        <p class="p2 m-t-5"
           *iCms="'description' of tile; content: 'html'; skipEmpty: true"></p>
        <p class="s1 m-t-2"
           *iCms="'copy' of tile; content: 'html'; skipEmpty: true"></p>

    </div>
    }
</div>
}
